import CreditCardHandler from './components/credit-card-handler.svelte';
import { cardForm, checkoutMode, installments, cardHash, waitingCardValidation } from './components/stores.js';
import { getCheckoutTotal } from './utils/get-checkout-total.js';
import { get as getStoreValue } from 'svelte/store';

const $ = window.jQuery;
const config = window.wc_juno_checkout_credit_card_script_data;
const body = $(document.body);

window.stores = {
  getStoreValue, checkoutMode, installments, cardHash, waitingCardValidation
}

// checkout custom elements
const el = {
  handler: null,
  form: null,
  submit: null,
  wrapper: null,
};

// sanitize values
config.user_id = +config.user_id;
config.sandbox = '1' == config.sandbox;
config.show_visual_card = '1' == config.show_visual_card;

// init checkout fields and stores
body.on('init_checkout', init);

if (body.hasClass('woocommerce-order-pay')) {
  $(function () {
    setTimeout(function () {
      init();
      onUpdate();
      onUpdated();
    }, 1000);
  });
}

function init () {
  el.form = $('form.checkout, form#order_review');
  el.submit = el.form.find('#place_order');
  $( 'body' ).on('click', '#place_order', handleSubmit);

  config.form = el.form[0];

  waitingCardValidation.subscribe(waiting => {
    if (waiting) {
      el.submit.prop('disabled', true);
    } else {
      const mode = getStoreValue(checkoutMode)
      el.submit.prop('disabled', false);
      if ('form' === mode) {
        const hash = getStoreValue(cardHash)
        // submit again if has a valid card hash
        if (isValidHash(hash)) {
          setTimeout(() => el.form.trigger('submit'), 100);
        } else {
          $([document.documentElement, document.body]).animate({
            scrollTop: $( '.payment_box.payment_method_juno-credit-card .wc-payment-form-fields' ).offset().top
          }, 1000 );
        }
      }
    }
  });

  body.on('checkout_error', function () {
    // invalidate the credit card hash
    if ( $(`#payment_method_${config.id}:checked`).length > 0 ) {
      cardHash.set('');
    }
  })
}

// reload the handler
body.on('update_checkout', onUpdate);

function onUpdate () {
  if ( el.handler ) {
    el.handler.$destroy();
    el.handler = null;
  }
}

body.on('updated_checkout', onUpdated);

function onUpdated () {
  const wrapper = el.form.find(`#${config.id}-form .fields-wrapper`)[0];

  wrapper.innerHTML = '';

  el.handler = new CreditCardHandler({
    target: wrapper,
    props: {
      config,
    }
  });

  installments.set(getCheckoutTotal(config.id));
}

// callbacks
function handleSubmit (e) {
  if ( ! $( '#payment_method_juno-credit-card' ).is( ':checked' ) ) {
    return true;
  }

  const mode = getStoreValue(checkoutMode)
  const waiting = getStoreValue(waitingCardValidation)

  if (!waiting) {
    if ('list' === mode) {
      // check cvc
      const form = getStoreValue(cardForm)
      if (form.selected && isValidCVC(form.cvc)) {
        return true
      } else {
        waitingCardValidation.set(true)
      }
    } else {
      // check credit card hash
      const hash = getStoreValue(cardHash)
      if (isValidHash(hash)) {
        return true
      } else {
        waitingCardValidation.set(true)
      }
    }
  }

  return false;
}

function isValidHash (hash) {
  const result = hash.length > 0 && hash !== 'error';
  if (!result) {
    body.animate({
      scrollTop: $(`#${config.id}-form`).offset().top
    }, 2000);
  }
  return result;
}

function isValidCVC (cvc) {
  cvc = cvc + '';
  return cvc && cvc.length >= 3;
}
